const state = {
  modalVisible: false,
  isTop: false,
  isFull: false,
  isMini: false,
  modalUrl: ''
};

const mutations = {
  SET_MODAL_VISIBLE(state, value) {
    state.modalVisible = value;
  },
  SET_IS_TOP(state, value) {
    state.isTop = value;
  },
  SET_IS_FULL(state, value) {
    state.isFull = value;
  },
  SET_IS_MINI(state, value) {
    state.isMini = value;
  },
  SET_MODAL_URL(state, value) {
    state.modalUrl = value;
  }
};

const actions = {
  openModal({ commit }, url = '') {
    commit('SET_MODAL_URL', url);
    commit('SET_MODAL_VISIBLE', true);
    commit('SET_IS_FULL', false);
    commit('SET_IS_MINI', false);
    commit('SET_IS_TOP', false);
  },
  closeModal({ commit }) {
    commit('SET_MODAL_VISIBLE', false);
    commit('SET_MODAL_URL', '');
    commit('SET_IS_FULL', false);
    commit('SET_IS_MINI', false);
  },
  toggleFull({ state, commit }) {
    if (state.isMini) {
      commit('SET_IS_MINI', false);
      commit('SET_IS_FULL', true);
    } else {
      commit('SET_IS_FULL', !state.isFull);
    }
  },
  toggleMini({ state, commit }) {
    if (state.isFull) {
      commit('SET_IS_FULL', false);
    }
    commit('SET_IS_MINI', !state.isMini);
  },
  toggleTop({ state, commit }) {
    commit('SET_IS_TOP', !state.isTop);
  },
  closeFloatModalIfNeeded({ state, dispatch }) {
    if (!state.isTop && state.modalVisible) {
      dispatch('closeModal');
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
